<template>
  <q-expansion-item class="access-products-item">
    <template v-slot:header>
      <strong>Access products</strong>
    </template>
    <div v-if="loadAccessProducts" class="flex items-center justify-center q-py-lg" style="padding: 30px 0">
      <q-spinner-gears size="40px" color="primary"></q-spinner-gears>
    </div>
    <div class="actions-table-holder q-mt-md" v-else-if="Object.keys(accessProducts).length">
      <q-table :columns="accessProductColumns" :rows="tableData" class="table-info access-products-table" flat>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="displayName" :props="props">
              <div>{{ props.row.displayName }}</div>
              <div class="long-descr">{{ props.row.displayDescription }}</div>
            </q-td>
            <q-td key="environment" :props="props">
              <div class="flex items-center">
                <q-icon
                  :name="isAccessProductExists(props.row.status) ? 'check_circle' : 'block'"
                  :color="isAccessProductExists(props.row.status) ? 'blue-5' : 'grey-5'"
                  class="q-mr-xs"
                  size="18px"
                  ><q-tooltip>{{ props.row.status }}</q-tooltip></q-icon
                >
                <span>{{ props.row.environment }}</span>
              </div>
            </q-td>
            <q-td key="getAccessLink" :props="props">
              <a v-if="isAccessProductExists(props.row.status)" :href="props.row.getAccessLink" target="_blank"
                >Get access</a
              >
              <p v-else>N/A</p>
            </q-td>
            <q-td key="actions" :props="props">
              <div class="flex items-center justify-end">
                <q-btn
                  flat
                  round
                  size="12px"
                  style="width: 30px; height: 40px"
                  class="btn--no-hover"
                  :icon="expandedAccessProducts.includes(props.row.key) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                  @click="toggleRow(props.row.key)"
                  :disable="!props.row.groups || !props.row.groups.length"
                />
              </div>
            </q-td>
          </q-tr>
          <q-tr v-show="expandedAccessProducts.includes(props.row.key)" :props="props">
            <q-td
              colspan="100%"
              style="background-color: rgba(247, 247, 247); padding: 5px 5px 5px 15px"
              class="q-pa-none"
            >
              <q-table
                :rows="props.row.groups"
                :columns="groupsColumns"
                class="table-api"
                row-key="name"
                hide-bottom
                flat
                dense
                separator="none"
              >
                <template v-slot:header></template>
                <template v-slot:body-cell-status="cellProps">
                  <q-td :props="cellProps" class="flex items-center q-pl-xl">
                    <b>{{ cellProps.row.name }}</b>
                    <q-icon
                      :name="isAccessProductExists(cellProps.row.status) ? 'check_circle' : 'block'"
                     :color="isAccessProductExists(cellProps.row.status) ? 'blue-5' : 'grey-5'"
                      class="q-ml-sm"
                      size="18px"
                      ><q-tooltip>{{ cellProps.row.status }}</q-tooltip></q-icon
                    >
                  </q-td>
                </template>
              </q-table>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div v-else class="flex full-width column items-center q-py-lg" style="padding: 30px 0">
      <q-icon name="hide_source" class="q-mb-sm" size="40px" color="primary"></q-icon>
      <span class="block" style="font-size: 16px">No data</span>
    </div>
  </q-expansion-item>
</template>

<script>
export default {
  name: 'AccessProductsTable',
  props: {
    accessProducts: {
      type: Object,
    },
    loadAccessProducts: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      accessProductColumns: [
        {
          label: 'Access role name',
          name: 'displayName',
          field: 'displayName',
          align: 'left',
        },
        {
          label: 'Environment',
          name: 'environment',
          field: 'environment',
          align: 'left',
        },
        {
          label: 'Request Access Link',
          name: 'getAccessLink',
          field: 'getAccessLink',
          align: 'left',
        },
        {
          label: 'AAD Groups',
          name: 'actions',
          field: 'actions',
          align: 'right',
        },
      ],
      groupsColumns: [
        {
          label: '',
          name: 'status',
          field: 'status',
          align: 'left',
        },
      ],
      expandedAccessProducts: [],
    };
  },
  computed: {
    tableData() {
      return Object.values(this.accessProducts)
        .flat(1)
        .map((accessProduct) => {
          const {
            displayName,
            entitlement: { longDescription: displayDescription, environment, status },
            group,
          } = accessProduct;

          return {
            key: `${displayName}-${environment}`,
            displayName,
            groups: group ? [group] : [],
            displayDescription,
            environment,
            getAccessLink: `https://swissreesm.service-now.com/contactone?id=request_access_rights&accessRightParam=${displayName}`,
            status,
          };
        });
    },
  },
  methods: {
    isAccessProductExists(status) {
      return status === 'exists';
    },
    toggleRow(rowKey) {
      const index = this.expandedAccessProducts.indexOf(rowKey);
      if (index > -1) {
        this.expandedAccessProducts.splice(index, 1);
      } else {
        this.expandedAccessProducts.push(rowKey);
      }
    },
  },
};
</script>

<style lang="sass">
.access-products-table
  tbody td::before
    display: none !important
  max-height: 380px
  thead tr
    height: 35px !important
  thead tr:first-child th
    background-color: #edeff5
  thead tr th
    position: sticky
    z-index: 1
    border-bottom-width: 0 !important
  thead tr:first-child th
    top: 0
  &.q-table--loading thead tr:last-child th
    top: 48px
</style>

<style lang="sass">
.table-api
  thead tr
    height: 30px !important
  thead tr:first-child th
    background: rgba(247,247,247) !important
  tbody tr
    background: rgba(247,247,247)
</style>

<style lang="scss" scoped>
.long-descr {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
